<div class="login-view">
  <!-- Decorative background elements -->
  <div class="background-decorators">
    <div class="bg-blob blob-1"></div>
    <div class="bg-blob blob-2"></div>
  </div>

  <div class="login-container">
    <!-- Header Animation -->
    <div class="header-group animate-fade-in-up">
      <h1 class="page-title">How would you like to continue?</h1>
      <p class="page-subtitle">Select the path that matches your current goal</p>
    </div>

    <div class="selection-grid">
      <!-- Individual Side (Secondary) - Delay 1 -->
      <div class="path-card path-individual animate-fade-in-up delay-1">
        <div class="illustration-wrapper">
          <img src="../../assets/individual.svg" alt="Individual">
        </div>
        <div class="card-content">
          <h2 class="card-title">I'm a Candidate</h2>
          <p class="card-desc">
            Invited to an assessment? Use the secure link from your email or WhatsApp to start immediately. No sign-up
            required.
          </p>
          <div class="action-area">
            <button class="btn btn-secondary disabled" title="Please use your invite link to start">
              Login as Candidate
            </button>
            <div class="helper-text">
              <span class="icon">ℹ</span>
              Have an invite link? Open it directly to begin.
            </div>
          </div>
        </div>
      </div>

      <!-- Company Side (Primary/Highlighted) - Delay 2 -->
      <div class="path-card path-company selectable animate-fade-in-up delay-2" (click)="goCompany()"
        (keyup.enter)="goCompany()" tabindex="0">
        <div class="premium-badge">Business Solution</div>
        <div class="illustration-wrapper">
          <img src="../../assets/company.svg" alt="Company">
        </div>
        <div class="card-content">
          <h2 class="card-title">I'm a Hiring Team</h2>
          <p class="card-desc">
            Scale your hiring with AI intelligence. Set up assessments, invite candidates, and analyze results in one
            centralized dashboard.
          </p>
          <div class="action-area">
            <button class="btn btn-primary" (click)="$event.stopPropagation(); goCompany()">
              Continue as Company
              <span class="btn-arrow">→</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer Badge - Staggered entrance -->
    <div class="footer-badge animate-fade-in-up delay-2">
      <div class="pulse-icon"></div>
      Start your free trial today. No credit card required.
    </div>
  </div>
</div>